import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { breakpoints } from 'gatsby-theme-docz/src/theme/breakpoints';
import global from 'gatsby-theme-docz/src/theme/global';
export var Content = _styled("div", {
  target: "ezrjzcr0"
})("width:100%;a.link{color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.link;
}, ";&:hover{opacity:0.9;}}@media screen and (max-width:", breakpoints.mobile, "px){table{display:block;overflow:auto;min-width:520px;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkM6XFxVc2Vyc1xcYWxleC5wZXp6aW5pXFxEb2N1bWVudHNcXFBST0dFVFRJXFxPUEVOSE9TUElUQUxcXE9QRU5IT1NQSVRBTF9ERVZFTE9QRVJfUE9SVEFMXFxub2RlX21vZHVsZXNcXGdhdHNieS10aGVtZS1kb2N6LW9oXFxzcmNcXGdhdHNieS10aGVtZS1kb2N6XFxjb21wb25lbnRzXFxMYXlvdXRcXGN1c3RvbS1zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWlDIiwiZmlsZSI6IkM6XFxVc2Vyc1xcYWxleC5wZXp6aW5pXFxEb2N1bWVudHNcXFBST0dFVFRJXFxPUEVOSE9TUElUQUxcXE9QRU5IT1NQSVRBTF9ERVZFTE9QRVJfUE9SVEFMXFxub2RlX21vZHVsZXNcXGdhdHNieS10aGVtZS1kb2N6LW9oXFxzcmNcXGdhdHNieS10aGVtZS1kb2N6XFxjb21wb25lbnRzXFxMYXlvdXRcXGN1c3RvbS1zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XHJcbmltcG9ydCB7YnJlYWtwb2ludHN9IGZyb20gJ2dhdHNieS10aGVtZS1kb2N6L3NyYy90aGVtZS9icmVha3BvaW50cyc7XHJcbmltcG9ydCBnbG9iYWwgZnJvbSAnZ2F0c2J5LXRoZW1lLWRvY3ovc3JjL3RoZW1lL2dsb2JhbCc7XHJcblxyXG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXHJcbiAgd2lkdGg6IDEwMCU7XHJcblxyXG4gIGEubGluayB7XHJcbiAgICBjb2xvcjogJHsoe3RoZW1lfSkgPT4gdGhlbWUuY29sb3JzLmxpbmt9O1xyXG5cclxuICAgICY6aG92ZXIge1xyXG4gICAgICBvcGFjaXR5OiAwLjk7XHJcbiAgICB9XHJcbiAgfVxyXG5cclxuICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiAke2JyZWFrcG9pbnRzLm1vYmlsZX1weCkge1xyXG4gICAgdGFibGUge1xyXG4gICAgICBkaXNwbGF5OiBibG9jaztcclxuICAgICAgb3ZlcmZsb3c6IGF1dG87XHJcbiAgICAgIG1pbi13aWR0aDogNTIwcHg7XHJcbiAgICB9XHJcbiAgfVxyXG5gO1xyXG5cclxuZXhwb3J0IGNvbnN0IGdsb2JhbFN0eWxlcyA9IHtcclxuICAuLi5nbG9iYWwsXHJcbiAgJyonOiB7XHJcbiAgICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcclxuICB9LFxyXG4gICcuaC1vOmhvdmVyJzoge1xyXG4gICAgdHJhbnNpdGlvbjogJ29wYWNpdHkgLjJzIGVhc2UnLFxyXG4gICAgb3BhY2l0eTogJy44JyxcclxuICB9LFxyXG4gICdidXR0b24sIHNlbGVjdCwgaW5wdXQsIHRleHRhcmVhJzoge1xyXG4gICAgZm9udEZhbWlseTogJ2luaGVyaXQnLFxyXG4gIH0sXHJcbiAgYToge1xyXG4gICAgY29sb3I6ICh7dGhlbWV9KSA9PiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcclxuICB9LFxyXG4gICdhOmhvdmVyJzoge1xyXG4gICAgdGV4dERlY29yYXRpb246ICd1bmRlcmxpbmUnLFxyXG4gIH0sXHJcbn07XHJcbiJdfQ== */"));

if (typeof Content !== 'undefined' && Content && Content === Object(Content) && Object.isExtensible(Content) && !Content.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Content, '__filemeta', {
    configurable: true,
    value: {
      name: "Content",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}

export var globalStyles = _objectSpread(_objectSpread({}, global), {}, {
  '*': {
    boxSizing: 'border-box'
  },
  '.h-o:hover': {
    transition: 'opacity .2s ease',
    opacity: '.8'
  },
  'button, select, input, textarea': {
    fontFamily: 'inherit'
  },
  a: {
    color: function color(_ref2) {
      var theme = _ref2.theme;
      return theme.colors.primary;
    }
  },
  'a:hover': {
    textDecoration: 'underline'
  }
});

if (typeof globalStyles !== 'undefined' && globalStyles && globalStyles === Object(globalStyles) && Object.isExtensible(globalStyles) && !globalStyles.hasOwnProperty('__filemeta')) {
  Object.defineProperty(globalStyles, '__filemeta', {
    configurable: true,
    value: {
      name: "globalStyles",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}